import React from 'react';
import PropTypes from 'prop-types';
import popover from 'helpers/Popover';
import {cleanHtml} from 'helpers/commonHelper';
import {host} from 'helpers/stableValues';

const createItemLink = (name, click, url, target, title) => {
  if (click) {
    return (<a onClick={click} dangerouslySetInnerHTML={{__html: cleanHtml(name)}} />);
  }

  if (url && url !== '#') {
    return (
      <a
        href={url}
        target={target}
        title={title}
        rel={url.includes(host) ? undefined : 'nofollow'}
        dangerouslySetInnerHTML={{__html: cleanHtml(name)}}
      />
    );
  }

  return (<div dangerouslySetInnerHTML={{__html: cleanHtml(name)}} />);
};

const renderItemLink = ({name, url, target, title, click, tooltip}, index) => {
  const itemLink = createItemLink(name, click, url, target, title);

  return (
    <li key={index} className="py-1">
      {
        tooltip ?
          popover({
            popOverText: tooltip,
            popoverId: name,
            placement: 'top',
            triggerNode: itemLink
          }) :
          itemLink
      }
    </li>
  );
};

renderItemLink.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  click: PropTypes.func
};

export {renderItemLink};